export default __webpack_public_path__ + "static/media/spotfit-screenshots.313e0c8c.jpg";